import { Injectable } from '@angular/core';

export type ExperienceCard = {
  label: string;
  items: string[];
  delay: string;
};

export type ExperienceContent = {
  badge: string;
  heading: string;
  lede: string;
  cards: ExperienceCard[];
};

@Injectable({ providedIn: 'root' })
export class ExperienceSectionService {
  readonly content: ExperienceContent = {
    badge: 'Why Ruffles & Shine',
    heading: 'Modern pet-care journeys with enterprise guardrails.',
    lede:
      'Your teams deliver features in their own service studios. The platform keeps trust, navigation, and accessibility unified so pet parents feel one seamless brand, not four separate apps.',
    cards: [
      {
        label: 'Parent experience',
        items: [
          'Single sign-on from booking through checkout.',
          'Context-aware journeys between grooming, clinic, and retail.',
          'Realtime updates, reminders, and receipts in one timeline.'
        ],
        delay: '160ms'
      },
      {
        label: 'Ops & care teams',
        items: [
          'Role-based surface for stylists, vets, and retail associates.',
          'Shared notification tray every team can publish to.',
          'Smart handoff notes to keep every visit consistent.'
        ],
        delay: '200ms'
      },
      {
        label: 'Platform readiness',
        items: [
          'Enterprise-grade routing for modular service teams.',
          'Design system that keeps every touchpoint on-brand.',
          'Ready to onboard clinic, daycare, retail, and future services.'
        ],
        delay: '240ms'
      }
    ]
  };
}
